import React, { useCallback, useState, useContext, useMemo, useEffect } from 'react'
import styles from './ModuleSingleRecordSections.module.css'
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CrmCheckBoxField from '../../../UI/Crm/Fields/CrmCheckBoxField'
import CrmDateTime from '../../../UI/Crm/Fields/CrmDateTime'
import CrmDateRange from '../../../UI/Crm/Fields/CrmDateRange'
import CrmNumberRange from '../../../UI/Crm/Fields/CrmNumberRange'
import CrmSelectField from '../../../UI/Crm/Fields/CrmSelectField'
import CrmTextField from '../../../UI/Crm/Fields/CrmTextField'
import CrmPlaceHolder from '../../../UI/Crm/Fields/CrmPlaceHolder';
import CrmSearchField from '../../../UI/Crm/Fields/CrmSearchField';
import CrmFileField from '../../../UI/Crm/Fields/CrmFileField';
import CrmEditableField from '../../../UI/Crm/Fields/CrmEditableField';
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext';
import { FaCheck } from "react-icons/fa6";
import SubModal from '../../../UI/Crm/SubModal/SubModal';
import ModuleRecordRelation from './ModuleRecordRelation';
import { unLinkRelatedRecords } from '../../../../axios/requests/baseRecordReq'
import FileManager from '../../FileManager/FileManager';
import { useSelector } from 'react-redux';
import { uploadFile } from '../../../../axios/requests/filesReq';

const ModuleSingleRecordSections = ({
    onEditSectionField,
    moduleSections,
    fieldValues,
    onFieldChange,
    alwaysOpenToEdit = false,
    recordId,
    onReload,
    onLinkClicked,
    onUnLinkClicked,
    relatedModuleObj,
    onSelectConv,
    OnAddToDialListClicked,
    supportRequired = true,
    isFilteringMode = false,
    onNestedDropdownChange
}) => {
    const [openSearchRecordModal, setOpenSearchRecordModal] = useState({
        isOpen: false,
        relatedToRecordId: undefined,
        moduleObj: undefined
    })
    const [showFileManagerState, setShowFileManager] = useState(false)
    const [nestedDropdownValues, setNestedDropdownValues] = useState({}) // Track nested dropdown selections
    const settings = useSelector(state => state.settings)
    const loggedUser = useSelector(state => state.login)
    //permissionType: state.login
    const [t] = useTranslation('crm')
    const alertCtx = useContext(AlertContext)
    const navigate = useNavigate();

    const isUpdatePermissions = relatedModuleObj?.userPermissions?.enabledActions?.update

    const searchRecordModalToggel = useCallback((fieldName, moduleObj, relatedToRecordId) => {
        setOpenSearchRecordModal((oldState) => ({ ...oldState, isOpen: !oldState?.isOpen, moduleObj, relatedToRecordId, fieldName }))
    }, [openSearchRecordModal])

    const handleUnlinkClicked = useCallback(async (field, sourceRecordId, targetRecordId, sourceModuleId, targetModuleId) => {
        unLinkRelatedRecords(sourceRecordId, targetRecordId, sourceModuleId, targetModuleId)
        onFieldChange({
            target: {
                name: field.name,
                value: undefined
            }
        })
        onEditSectionField(field._id, 'isEditable', false, false)
    }, [])

    const onLinkClickedHandler = useCallback((selectedRows) => {
        if (onLinkClicked) onLinkClicked(selectedRows, openSearchRecordModal.fieldName, openSearchRecordModal.moduleObj)
        onFieldChange({
            target: {
                name: openSearchRecordModal.fieldName,
                value: selectedRows[0]
            }
        })
    }, [onLinkClicked, openSearchRecordModal.fieldName, openSearchRecordModal.moduleObj])

    const onUnLinkClickedHandler = useCallback((selectedRows) => {
        if (onUnLinkClicked) onUnLinkClicked(selectedRows, openSearchRecordModal.fieldName, openSearchRecordModal.moduleObj)
    }, [onUnLinkClicked, openSearchRecordModal.fieldName, openSearchRecordModal.moduleObj])

    const onAttachFileClickedHandler = useCallback(async (fileArr = []) => {//TODO:
        if (fileArr?.length > 0) {
            let toLinkFile = fileArr[0]
            if (!toLinkFile) return

            if (!toLinkFile._id) {// is uploaded file
                toLinkFile = await uploadFile(toLinkFile)
            }
            // Save only important properties
            //////////////////////////////////////
            delete toLinkFile.supportFileManager
            delete toLinkFile.companyId
            delete toLinkFile.userId
            delete toLinkFile.fileCategory
            delete toLinkFile.createdAt
            delete toLinkFile.updatedAt
            //////////////////////////////////////

            onFieldChange({
                target: {
                    name: showFileManagerState.fieldName,
                    value: toLinkFile
                }
            })
        }
        setShowFileManager()

    }, [showFileManagerState])

    const onClearFileAttachment = useCallback((fieldName) => {
        onFieldChange({
            target: {
                name: fieldName,
                value: null
            }
        })
    }, [])

    const onShowFileManagerClickedHandler = useCallback((fieldName) => { //getting files after it was added to galler
        setShowFileManager({ isOpen: true, fieldName })
    })

    // Helper function to get child dropdown options based on parent selection
    const getChildDropdownOptions = useCallback((parentField, parentValue, level = 0) => {
        if (!parentField?.dropDownId?.dropDownItems || !parentValue) {
            return [];
        }


        // For level 0, search in the original dropDownItems
        if (level === 0) {
            const parentOption = parentField.dropDownId.dropDownItems.find(item => item.value === parentValue);

            if (!parentOption?.children) {
                return [];
            }

            // Transform children to match expected dropdown format
            const transformedChildren = parentOption.children.map(child => ({
                key: child.key,
                value: child.value,
                children: child.children || [] // Preserve children for deeper nesting
            }));

            return transformedChildren;
        } else {
            // For deeper levels, we need to traverse the nested structure
            const baseFieldName = parentField.name.split('_child_')[0];
            let currentLevel = 0;
            let currentOptions = parentField.dropDownId.dropDownItems;


            // Traverse down the levels to find the right parent option
            while (currentLevel < level) {
                let levelValue;
                if (currentLevel === 0) {
                    // Handle both consolidated object and plain string value
                    const fieldValue = fieldValues[baseFieldName];
                    if (typeof fieldValue === 'object' && fieldValue.parent) {
                        levelValue = fieldValue.parent;
                    } else {
                        levelValue = fieldValue;
                    }
                } else {
                    levelValue = nestedDropdownValues[`${baseFieldName}_child_${currentLevel - 1}`];
                }


                const levelOption = currentOptions.find(item => item.value === levelValue);

                if (!levelOption?.children) {
                    return [];
                }

                currentOptions = levelOption.children;
                currentLevel++;
            }

            const parentOption = currentOptions.find(item => item.value === parentValue);

            if (!parentOption?.children) {
                return [];
            }

            // Transform children to match expected dropdown format
            const transformedChildren = parentOption.children.map(child => ({
                key: child.key,
                value: child.value,
                children: child.children || [] // Preserve children for deeper nesting
            }));

            return transformedChildren;
        }
    }, [fieldValues, nestedDropdownValues]);

    // Helper function to generate child dropdown field names
    const getChildFieldName = useCallback((parentFieldName, level) => {
        return `${parentFieldName}_child_${level}`;
    }, []);

    // Helper function to generate child dropdown fields
    const generateChildDropdownFields = useCallback((field, parentValue, level = 0) => {
        const childOptions = getChildDropdownOptions(field, parentValue, level);
        if (!childOptions.length) return [];

        const childFieldName = getChildFieldName(field.name, level);
        const childValue = nestedDropdownValues[childFieldName] || fieldValues[childFieldName] || '';

        const childField = {
            ...field,
            name: childFieldName,
            label: (() => {

                // Get custom child level name from parent option
                const getCustomChildLevelName = (baseField, currentLevel) => {

                    if (currentLevel === 0) {
                        // For first level, check the parent field's selected option
                        const parentValue = fieldValues[baseField.name];
                        const parentOption = baseField.dropDownId?.dropDownItems?.find(item => item.value === parentValue);
                        return parentOption?.childLevelName;
                    } else {
                        // For deeper levels, traverse to find the option that contains the childLevelName for this level
                        let current = null;

                        // Start from the root level
                        const rootValue = fieldValues[baseField.name];
                        const rootOption = baseField.dropDownId?.dropDownItems?.find(item => item.value === rootValue);

                        if (!rootOption) {
                            return null;
                        }

                        current = rootOption;

                        // Traverse to the level that contains the childLevelName for our target level
                        for (let i = 0; i < currentLevel; i++) {
                            // If this is the target level (level before currentLevel), return this option's childLevelName
                            if (i === currentLevel - 1) {
                                const result = current?.childLevelName;
                                return result;
                            }

                            // Move to the next level
                            if (!current.children) {
                                return null;
                            }

                            // Get the value for the next level
                            const nextLevelFieldName = `${baseField.name}_child_${i}`;
                            const nextValue = nestedDropdownValues[nextLevelFieldName] || fieldValues[nextLevelFieldName];

                            current = current.children.find(item => item.value === nextValue);
                            if (!current) {
                                return null;
                            }
                        }

                        // This shouldn't be reached, but just in case
                        const result = current?.childLevelName;
                        return result;
                    }
                };

                const customName = getCustomChildLevelName(field, level);
                return customName || `${field.label} - ${t('Child dropdown level {{level}}', { level: level + 1 })}`;
            })(),
            dropDownId: { dropDownItems: childOptions },
            _id: `${field._id}_child_${level}`,
            required: childOptions.some(opt => opt.required) && childValue !== ''
        };

        const childFields = [childField];

        // Recursively generate deeper levels if current level has a value
        if (childValue) {
            const deeperFields = generateChildDropdownFields(field, childValue, level + 1);
            childFields.push(...deeperFields);
        }

        return childFields;
    }, [nestedDropdownValues, fieldValues, getChildDropdownOptions, getChildFieldName]);


    // Handler for nested dropdown changes
    const handleNestedDropdownChange = useCallback((e) => {
        const { name, value } = e.target;

        // Clear deeper level selections when child changes
        const newNestedValues = { ...nestedDropdownValues };
        const fieldParts = name.split('_child_');
        const childFieldsToReset = [];

        if (fieldParts.length > 1) {
            const baseFieldName = fieldParts[0];
            const currentLevel = parseInt(fieldParts[1]);

            // Clear all deeper levels from local state
            Object.keys(newNestedValues).forEach(key => {
                const keyParts = key.split('_child_');
                if (keyParts[0] === baseFieldName && parseInt(keyParts[1]) > currentLevel) {
                    childFieldsToReset.push(key);
                    delete newNestedValues[key];
                }
            });
        }

        newNestedValues[name] = value;
        setNestedDropdownValues(newNestedValues);

        // Clear deeper level child field values from parent component's fieldValues
        childFieldsToReset.forEach(childFieldName => {
            onFieldChange({
                target: {
                    name: childFieldName,
                    value: undefined
                }
            });
        });

        // Notify parent about nested dropdown changes
        if (onNestedDropdownChange) {
            onNestedDropdownChange(newNestedValues);
        }

        // Save the current child value for UI state management
        // We'll consolidate later during form submission
        onFieldChange({
            target: {
                name: name,
                value: value
            }
        });
    }, [nestedDropdownValues, onFieldChange, onNestedDropdownChange]);

    // Handler for parent dropdown changes (when field has cascading children)
    const handleParentDropdownChange = useCallback((e, field) => {
        const { name, value } = e.target;

        // Clear all nested dropdown values for this field from local state
        const newNestedValues = { ...nestedDropdownValues };
        const childFieldsToReset = [];

        Object.keys(newNestedValues).forEach(key => {
            if (key.startsWith(name + '_child_')) {
                childFieldsToReset.push(key);
                delete newNestedValues[key];
            }
        });
        setNestedDropdownValues(newNestedValues);

        // Also clear child field values from parent component's fieldValues
        childFieldsToReset.forEach(childFieldName => {
            onFieldChange({
                target: {
                    name: childFieldName,
                    value: undefined
                }
            });
        });

        // Update the parent field value for UI rendering
        onFieldChange({
            target: {
                name: name,
                value: value
            }
        });

        // Notify parent about nested dropdown changes
        if (onNestedDropdownChange) {
            onNestedDropdownChange(newNestedValues);
        }
    }, [nestedDropdownValues, onFieldChange, onNestedDropdownChange]);

    // Effect to extract consolidated cascading dropdown data when loading existing records
    useEffect(() => {
        if (!moduleSections || !fieldValues) return;

        const newNestedValues = {};
        const fieldsToUpdate = {};
        let hasConsolidatedData = false;
        let shouldUpdate = false;

        moduleSections.forEach(section => {
            if (!section.fields) return;

            section.fields.forEach(field => {
                if (field.type === 'select' && fieldValues[field.name]) {
                    const fieldValue = fieldValues[field.name];

                    // Check if this is a consolidated cascading dropdown value
                    // Only extract if we haven't already extracted or if the user hasn't made manual changes
                    if (typeof fieldValue === 'object' && fieldValue.parent && fieldValue.children) {

                        // Check if user has already made changes to this field's nested dropdowns
                        const hasExistingNestedValues = Object.keys(nestedDropdownValues).some(key =>
                            key.startsWith(field.name + '_child_')
                        );

                        // Only extract consolidated data if we haven't already done so for this field
                        if (!hasExistingNestedValues) {
                            hasConsolidatedData = true;

                            // Extract children values into nested state
                            // Sort children by level to ensure proper sequential mapping
                            const sortedChildren = [...fieldValue.children].sort((a, b) => a.level - b.level);

                            sortedChildren.forEach((child, index) => {
                                // Map to sequential levels (0, 1, 2, ...) for UI consistency
                                const childFieldName = `${field.name}_child_${index}`;
                                newNestedValues[childFieldName] = child.value;

                                // Check if we need to update (value doesn't exist or is different)
                                if (!nestedDropdownValues[childFieldName] || nestedDropdownValues[childFieldName] !== child.value) {
                                    shouldUpdate = true;
                                }
                            });

                            // Update field value to just the parent for UI display
                            // Only if the current field value is still the consolidated object
                            if (typeof fieldValue === 'object' && fieldValue.parent) {
                                fieldsToUpdate[field.name] = fieldValue.parent;
                                shouldUpdate = true;
                            }

                        }
                    }
                }
            });
        });

        if (hasConsolidatedData && shouldUpdate) {
            // Update nested dropdown values only if they're different
            if (Object.keys(newNestedValues).length > 0) {
                setNestedDropdownValues(prev => {
                    const merged = { ...prev, ...newNestedValues };

                    // Notify parent about extracted nested dropdown values
                    if (onNestedDropdownChange) {
                        onNestedDropdownChange(merged);
                    }

                    return merged;
                });
            }

            // Update field values to parent-only for UI display
            if (Object.keys(fieldsToUpdate).length > 0) {
                Object.keys(fieldsToUpdate).forEach(fieldName => {
                    onFieldChange({
                        target: {
                            name: fieldName,
                            value: fieldsToUpdate[fieldName]
                        }
                    });
                });
            }
        }
    }, [moduleSections, fieldValues, nestedDropdownValues, onFieldChange]);

    // Enhanced validation function for nested dropdown fields
    const validateNestedDropdownFields = useCallback((moduleSections, fieldValues, nestedValues) => {
        const errors = [];

        if (!moduleSections) return errors;

        moduleSections.forEach(section => {
            if (!section.fields) return;

            section.fields.forEach(field => {
                if (field.type === 'select') {
                    const parentValue = fieldValues[field.name];
                    if (parentValue) {
                        // Validate child fields recursively
                        const validateChildLevel = (parentField, parentVal, level = 0) => {
                            const childOptions = getChildDropdownOptions(parentField, parentVal, level);
                            if (!childOptions.length) return;

                            const childFieldName = getChildFieldName(parentField.name, level);
                            const childValue = nestedValues[childFieldName] || fieldValues[childFieldName];

                            // Check if child field is required
                            const selectedParentOption = parentField.dropDownId?.dropDownItems?.find(item => item.value === parentVal);
                            if (level === 0 && selectedParentOption?.children) {
                                const requiredChild = selectedParentOption.children.find(child => child.required);
                                if (requiredChild && !childValue) {
                                    errors.push({
                                        fieldName: childFieldName,
                                        message: t('This field is required when parent is selected'),
                                        level: level
                                    });
                                }
                            }

                            // Recursively validate deeper levels
                            if (childValue) {
                                validateChildLevel(parentField, childValue, level + 1);
                            }
                        };

                        validateChildLevel(field, parentValue);
                    }
                }
            });
        });

        return errors;
    }, [getChildDropdownOptions, getChildFieldName, t]);

    // Circular dependency prevention
    const checkCircularDependency = useCallback((dropdownConfig) => {
        const visited = new Set();
        const recursionStack = new Set();

        const hasCycle = (nodeId, path = []) => {
            if (recursionStack.has(nodeId)) {
                return true; // Found a cycle
            }

            if (visited.has(nodeId)) {
                return false; // Already processed this node
            }

            visited.add(nodeId);
            recursionStack.add(nodeId);

            // Check children (this would need to be implemented based on your dropdown config structure)
            // For now, this is a placeholder for the circular dependency check logic

            recursionStack.delete(nodeId);
            return false;
        };

        return hasCycle;
    }, []);

    // Function to consolidate cascading dropdown data before form submission
    const consolidateCascadingDropdowns = useCallback((formData, sections) => {
        if (!sections) return formData;

        const consolidatedData = { ...formData };

        sections.forEach(section => {
            if (!section.fields) return;

            section.fields.forEach(field => {
                if (field.type === 'select' && field.dropDownId?.dropDownItems?.some(item => item.children && item.children.length > 0)) {
                    // This is a parent field with cascading children
                    const parentValue = consolidatedData[field.name];
                    if (parentValue) {
                        const children = [];

                        // First, collect child values from form data
                        Object.keys(consolidatedData).forEach(key => {
                            if (key.startsWith(field.name + '_child_')) {
                                const level = parseInt(key.split('_child_')[1]);
                                const childValue = consolidatedData[key];
                                if (childValue) {
                                    children.push({ level, value: childValue });
                                    // Remove individual child fields from form data
                                    delete consolidatedData[key];
                                }
                            }
                        });

                        // Also collect child values from nestedDropdownValues state
                        Object.keys(nestedDropdownValues).forEach(key => {
                            if (key.startsWith(field.name + '_child_')) {
                                const level = parseInt(key.split('_child_')[1]);
                                const childValue = nestedDropdownValues[key];
                                if (childValue) {
                                    // Check if we already have this level from form data
                                    const existingChild = children.find(c => c.level === level);
                                    if (existingChild) {
                                        // Update existing value with the one from nested state (more recent)
                                        existingChild.value = childValue;
                                    } else {
                                        // Add new child value
                                        children.push({ level, value: childValue });
                                    }
                                }
                            }
                        });

                        // Sort children by level
                        children.sort((a, b) => a.level - b.level);

                        // Create consolidated structure only if there are children
                        if (children.length > 0) {
                            consolidatedData[field.name] = {
                                parent: parentValue,
                                children: children
                            };
                        }
                    }
                }
            });
        });

        return consolidatedData;
    }, [nestedDropdownValues]);

    // Helper function to build cascading dropdown display value for non-edit mode
    const buildCascadingDisplayValue = useCallback((field, consolidatedValue) => {
        if (!consolidatedValue || typeof consolidatedValue !== 'object' || !consolidatedValue.parent) {
            return null;
        }

        const parts = [];

        // Add parent value label
        const parentOption = field.dropDownId?.dropDownItems?.find(item => item.value === consolidatedValue.parent);
        if (parentOption) {
            parts.push(parentOption.key);
        }

        // Add child values
        if (consolidatedValue.children && consolidatedValue.children.length > 0) {
            // Sort children by level to ensure correct order
            const sortedChildren = [...consolidatedValue.children].sort((a, b) => a.level - b.level);

            let currentOptions = field.dropDownId?.dropDownItems;
            let currentParentValue = consolidatedValue.parent;

            for (const child of sortedChildren) {
                // Find the parent option to get children
                const parentOption = currentOptions?.find(item => item.value === currentParentValue);
                if (parentOption?.children) {
                    const childOption = parentOption.children.find(item => item.value === child.value);
                    if (childOption) {
                        parts.push(childOption.key);
                        currentOptions = parentOption.children;
                        currentParentValue = child.value;
                    }
                }
            }
        }

        return parts.join(' → ');
    }, []);

    const onActionHandler = useCallback(({ action, name, value, type }) => {

        if (!value || !action) return alertCtx.showAlert(t('fail'), t('Failed to retrieve data from the grid.'), 'sm')
        switch (action) {
            case 'copy':
                let processedValue = value
                // Convert 972 Israeli phone numbers to local format
                if (value.trim().startsWith('+972')) {
                    processedValue = '0' + value.trim().slice(4);
                }
                navigator.clipboard.writeText(processedValue)
                return alertCtx.showAlert(t('success'), t('Copied to clipboard successfully.'), 'sm')
            case 'call':
                OnAddToDialListClicked?.(value)
                break;
            case 'whatsapp':
                onSelectConv?.(value, 'whatsapp')
                break;
            case 'sms':
                onSelectConv?.(value, 'sms')
                break;
            case 'mail':
                onSelectConv?.(value, 'mail')
                break
            default:
                alertCtx.showAlert(t('success'), t('Invalid action.'), 'sm')
        }
        navigate('/')
    }, [])

    const getFieldElementContainer = useCallback((field, isLastTwo = false) => {
        let fieldElement

        // Handle consolidated cascading dropdown values for display
        let fieldValue = fieldValues[field.name] || '';
        if (field.type === 'select' && typeof fieldValue === 'object' && fieldValue.parent) {
            fieldValue = fieldValue.parent;
        }

        const commonProps = {
            label: field.label,
            name: field.name,
            type: field.type,
            errorMsg: field.errorMsg,
            required: supportRequired && field.required,
            tooltip: field.tooltip,
            value: fieldValue,
            onChange: onFieldChange,
            autoComplete: 'off',
            isEditableField: field.isEditableField,
            maxNumber: field.maxNumber
        }

        if (field.type === 'reference') {//Hold reference to module baserecord
            // debugger
            commonProps.value = fieldValues?.[field.name]?.crmName || ''
            commonProps.referenceObj = fieldValues?.[field.name]
            commonProps.moduleType = field?.refModelId?.name
            // if(commonProps.value)debugger
        }
        if (field.type === 'file') { // Hold reference to file module document
            commonProps.value = fieldValues?.[field.name]?.fileName
            commonProps.referenceObj = fieldValues?.[field.name]
        }
        // System fields should not be editable by users, but can be filtered
        const isSystemField = ['createdById', 'updatedById', 'createdAt', 'updatedAt' ].includes(field.name);//'status', 'source'
        if (isSystemField) {
            commonProps.isEditableField = false
        }

        if (field.isEditable || field.type === 'placeholder' || alwaysOpenToEdit || isFilteringMode) {
            // For new records (alwaysOpenToEdit), don't show fields with isEditableField: false
            // BUT still show them in filtering mode, and always show system fields in filtering
            if (alwaysOpenToEdit && !isFilteringMode && !commonProps.isEditableField && field.type !== 'placeholder') {
                return null;
            }

            // Hide reference fields that point to the parent module when creating a related record
            // The relationship will be automatically created after saving
            if (alwaysOpenToEdit && !isFilteringMode && field.type === 'reference' && relatedModuleObj && field.refModelId?._id === relatedModuleObj._id) {
                return null;
            }
            
            // Check if field should be editable by user
            const isUserEditable = commonProps.isEditableField && (field.isEditable || alwaysOpenToEdit);
            // Show in filter mode if: filtering mode AND (system field OR field is not editable by design)
            const showInFilterOnly = isFilteringMode && (isSystemField || !commonProps.isEditableField);
            
            switch (field.type) {
                case 'text':
                case 'textarea':
                case 'email':
                case 'phone':
                    fieldElement = (isUserEditable || showInFilterOnly) ?
                        <CrmTextField {...commonProps} disabled={showInFilterOnly ? false : !isUserEditable} /> :
                        <CrmTextField {...commonProps} disabled={true} />
                    break
                case 'number':
                    if (isFilteringMode) {
                        fieldElement = <CrmNumberRange {...commonProps} />
                    } else {
                        fieldElement = (isUserEditable || showInFilterOnly) ?
                            <CrmTextField {...commonProps} type="number" disabled={showInFilterOnly ? false : !isUserEditable} /> :
                            <CrmTextField {...commonProps} type="number" disabled={true} />
                    }
                    break
                case 'date':
                case 'datetime':
                    if (isUserEditable) {
                        fieldElement = <CrmDateTime {...commonProps} />
                    } else if (showInFilterOnly) {
                        fieldElement = <CrmDateRange {...commonProps} />
                    } else {
                        // When field is in edit mode but not actually editable, hide calendar icon
                        const shouldHideCalendar = !commonProps.isEditableField && field.isEditable;
                        fieldElement = <CrmDateTime {...commonProps} disabled={true} readOnly={shouldHideCalendar} />
                    }
                    break
                case 'boolean':
                    fieldElement = (isUserEditable || showInFilterOnly) ?
                        <CrmCheckBoxField {...commonProps} disabled={showInFilterOnly ? false : !isUserEditable} /> :
                        <CrmCheckBoxField {...commonProps} disabled={true} />
                    break
                case 'placeholder':
                    fieldElement = <CrmPlaceHolder />
                    break
                case 'select':
                    const options = field.dropDownId?.dropDownItems ? field.dropDownId.dropDownItems.map(item => ({ ...item, label: item.key })) : []
                    const isChildField = field.name.includes('_child_');
                    const hasChildren = field.dropDownId?.dropDownItems?.some(item => item.children && item.children.length > 0);

                    let changeHandler = onFieldChange;
                    if (isChildField) {
                        changeHandler = handleNestedDropdownChange;
                    } else if (hasChildren) {
                        changeHandler = (e) => handleParentDropdownChange(e, field);
                    }

                    const selectProps = {
                        ...commonProps,
                        options,
                        isFilteringMode,
                        onChange: changeHandler
                    };

                    fieldElement = (isUserEditable || showInFilterOnly) ?
                        <CrmSelectField {...selectProps} disabled={showInFilterOnly ? false : !isUserEditable} /> :
                        <CrmSelectField {...selectProps} disabled={true} />
                    break
                case 'reference':
                    if (isUserEditable || showInFilterOnly) {
                        fieldElement = <CrmSearchField
                            {...commonProps}
                            onSearchClick={searchRecordModalToggel}
                            moduleObj={field.refModelId}
                            relatedToRecordId={recordId}
                            onClearClick={() => handleUnlinkClicked(field, recordId, fieldValues?.[field.name]?._id, fieldValues.moduleId, fieldValues?.[field.name]?.moduleId)}
                            isFilteringMode={isFilteringMode}
                            disabled={showInFilterOnly ? false : !isUserEditable}
                        />
                    } else {
                        fieldElement = <CrmSearchField
                            {...commonProps}
                            moduleObj={field.refModelId}
                            disabled={true}
                        />
                    }
                    break
                case 'file'://CrmFileField TODO:
                    fieldElement = (isUserEditable || showInFilterOnly) ? 
                        <CrmFileField
                            {...commonProps}
                            onSelectFileClicked={onShowFileManagerClickedHandler}
                            onClearClick={onClearFileAttachment}
                            disabled={!isUserEditable}
                        /> : 
                        <CrmFileField {...commonProps} disabled={true} />
                    break;
                default:
                    fieldElement = <CrmPlaceHolder />
            }
        }
        else {
            let valueLabel
            let displayValue = commonProps.value

            if (field.type === 'select' && commonProps.value) {
                // Handle consolidated cascading dropdown values
                if (typeof commonProps.value === 'object' && commonProps.value.parent) {
                    displayValue = commonProps.value.parent
                    valueLabel = buildCascadingDisplayValue(field, commonProps.value)
                } else {
                    valueLabel = (field.dropDownId?.dropDownItems?.find(item => item.value === commonProps.value))?.key
                }
            }

            fieldElement = <CrmEditableField
                isUpdatePermissions={isUpdatePermissions}
                {...commonProps}
                value={displayValue}
                valueLabel={valueLabel}
                mediaTokenData={loggedUser?.mediaTokenData}
                onClick={() => onEditSectionField(field._id, 'isEditable', true)}
                onFieldAction={onActionHandler}
            />
        }
        if (!fieldElement) return
        return <div className={`${styles['field-container']} ${field.isEditable && styles['field-container--Edit']} ${field.type !== 'placeholder' && (!isLastTwo || !field.isEditable) && styles['field-container--dashed']}`}>
            <div className={`${field.isEditable && styles['field-editable-container']}`}>
                {fieldElement}
            </div>
            {
                field.isEditable &&
                <div className={styles['field-btn']} onClick={() => onEditSectionField(field._id, 'isEditable', true)}>
                    <FaCheck />
                </div>
            }
        </div>
    }, [fieldValues, supportRequired])

    // Special function to create nested dropdown field containers with correct onChange handler
    const getNestedFieldElementContainer = useCallback((field, isLastTwo = false) => {

        // Initialize parent field variables at function scope
        let parentFieldId = field._id;
        let parentField = field;

        // Check if this is a child dropdown field and get parent field info
        const isChildDropdownField = field.name.includes('_child_');
        if (isChildDropdownField) {
            // Extract parent field name and find parent field ID
            const parentFieldName = field.name.split('_child_')[0];

            // Find the parent field in moduleSections to get its ID and state
            let foundParentField = null;
            moduleSections?.forEach(section => {
                section.fields?.forEach(sectionField => {
                    if (sectionField.name === parentFieldName) {
                        foundParentField = sectionField;
                    }
                });
            });

            if (foundParentField) {
                parentFieldId = foundParentField._id;
                parentField = foundParentField;
            } else {
                // Fallback to using the current field
                parentField = field;
            }
        }

        // For nested dropdowns, we need to use the correct value and onChange handler
        if (field.isNestedDropdown) {
            let fieldElement;

            // Get custom child level name for nested dropdown fields
            const getCustomLabelForNestedField = (nestedField) => {

                // Extract level from field name (e.g., dfcsdefdsfsd_child_0 -> level 1)
                const match = nestedField.name.match(/_child_(\d+)$/);
                if (!match) {
                    return nestedField.label;
                }

                const level = parseInt(match[1]) + 1; // Convert to 1-based level
                const baseFieldName = nestedField.name.replace(/_child_\d+$/, '');

                // Find the original field to get dropdown data
                let originalField = null;
                moduleSections?.forEach(section => {
                    section.fields?.forEach(field => {
                        if (field.name === baseFieldName) {
                            originalField = field;
                        }
                    });
                });

                if (!originalField) {
                    return nestedField.label;
                }

                // Get parent option that contains childLevelName for this level
                const getParentOptionForLevel = (targetLevel) => {
                    if (targetLevel === 1) {
                        // Level 1: get from root field's selected option
                        const rootValue = fieldValues[baseFieldName];
                        // Handle consolidated object format from saved cascading dropdown data
                        const actualRootValue = (typeof rootValue === 'object' && rootValue?.parent) ? rootValue.parent : rootValue;
                        const rootOption = originalField.dropDownId?.dropDownItems?.find(item => item.value === actualRootValue);
                        return rootOption;
                    } else {
                        // Level 2+: traverse to find the correct parent
                        let current = originalField.dropDownId?.dropDownItems;
                        let currentValue = fieldValues[baseFieldName];
                        // Handle consolidated object format for root value
                        currentValue = (typeof currentValue === 'object' && currentValue?.parent) ? currentValue.parent : currentValue;

                        for (let i = 0; i < targetLevel - 1; i++) {
                            const option = current?.find(item => item.value === currentValue);
                            if (!option?.children) {
                                return null;
                            }

                            current = option.children;

                            // Get next level value
                            const nextFieldName = `${baseFieldName}_child_${i}`;
                            let nextValue = nestedDropdownValues[nextFieldName] || fieldValues[nextFieldName];
                            // Handle consolidated object format for child values
                            currentValue = (typeof nextValue === 'object' && nextValue?.parent) ? nextValue.parent : nextValue;
                        }

                        // Find the final parent option
                        const parentOption = current?.find(item => item.value === currentValue);
                        return parentOption;
                    }
                };

                const parentOption = getParentOptionForLevel(level);
                const customName = parentOption?.childLevelName;

                if (customName) {
                    return customName;
                } else {
                    return nestedField.label; // Fallback to original label
                }
            };

            const customLabel = getCustomLabelForNestedField(field);

            const commonProps = {
                label: customLabel,
                name: field.name,
                type: field.type,
                errorMsg: field.errorMsg,
                required: supportRequired && field.required,
                tooltip: field.tooltip,
                value: isFilteringMode ? (fieldValues[field.name] || []) : (field.nestedValue || ''), // Use fieldValues for filtering mode
                onChange: isFilteringMode ? onFieldChange : handleNestedDropdownChange, // Use appropriate handler
                autoComplete: 'off',
                isEditableField: field.isEditableField,
                maxNumber: field.maxNumber
            };

            if (field.isEditable || field.type === 'placeholder' || alwaysOpenToEdit) {
                const isUserEditable = commonProps.isEditableField && (field.isEditable || alwaysOpenToEdit);

                if (field.type === 'select') {

                    // Use the same pattern as the parent dropdown
                    const options = field.dropDownId?.dropDownItems ? field.dropDownId.dropDownItems.map(item => ({ ...item, label: item.key })) : []
                    const selectProps = {
                        ...commonProps,
                        options,
                        isFilteringMode, // Use the same filtering mode as parent
                        onChange: isFilteringMode ? onFieldChange : handleNestedDropdownChange
                    };

                    fieldElement = isUserEditable ?
                        <CrmSelectField {...selectProps} /> :
                        <CrmSelectField {...selectProps} disabled={true} />;
                }
            } else {
                let valueLabel;
                if (field.type === 'select' && commonProps.value) {
                    valueLabel = (field.dropDownId?.dropDownItems?.find(item => item.value === commonProps.value))?.key;
                }

                fieldElement = <CrmEditableField isUpdatePermissions={isUpdatePermissions} {...commonProps} valueLabel={valueLabel} mediaTokenData={loggedUser?.mediaTokenData} onClick={() => onEditSectionField(parentFieldId, 'isEditable', true)} onFieldAction={onActionHandler} />;
            }

            if (!fieldElement) return null;
            // In filtering mode, always apply edit styling for consistent height
            const shouldUseEditStyling = isFilteringMode || parentField.isEditable;
            // In filtering mode, use specific styling to match parent field size
            const containerClasses = isFilteringMode
                ? `${styles['field-container']} ${shouldUseEditStyling ? styles['field-container--Edit'] : ''} ${field.type !== 'placeholder' && (!isLastTwo || !shouldUseEditStyling) ? styles['field-container--dashed'] : ''}`
                : `${styles['field-container']} ${shouldUseEditStyling && styles['field-container--Edit']} ${field.type !== 'placeholder' && (!isLastTwo || !shouldUseEditStyling) && styles['field-container--dashed']}`;

            const containerStyle = isFilteringMode ? {
                width: '100%',
                margin: '0 0 10px 0',
                boxSizing: 'border-box'
            } : {};

            return (
                <div className={containerClasses} style={containerStyle}>
                    <div className={`${shouldUseEditStyling && styles['field-editable-container']}`}
                         style={isFilteringMode ? { width: '100%' } : {}}>
                        {fieldElement}
                    </div>
                    {/* Show FaCheck button only if parent field is editable and not in filtering mode */}
                    {
                        !isFilteringMode && parentField.isEditable && (
                            <div className={styles['field-btn']} onClick={() => onEditSectionField(parentFieldId, 'isEditable', true)}>
                                <FaCheck />
                            </div>
                        )
                    }
                </div>
            );
        }

        // For non-nested fields, use the regular function
        return getFieldElementContainer(field, isLastTwo);
    }, [nestedDropdownValues, handleNestedDropdownChange, supportRequired, alwaysOpenToEdit, isUpdatePermissions, loggedUser, onEditSectionField, onActionHandler, getFieldElementContainer, moduleSections]);

    // Recursive function to create nested dropdown containers
    const createNestedDropdownContainers = useCallback((field, parentValue, level = 0, islastTwo = false) => {
        const buildContainers = (currentField, currentParentValue, currentLevel) => {
            const childOptions = getChildDropdownOptions(currentField, currentParentValue, currentLevel);

            if (!childOptions.length) {
                return [];
            }

            // Fix: Use the base field name, not the current field name which might already include _child_
            const baseFieldName = currentField.name.split('_child_')[0];
            const childFieldName = getChildFieldName(baseFieldName, currentLevel);
            const childValue = nestedDropdownValues[childFieldName] || fieldValues[childFieldName] || '';

            // Get the display name of the parent value
            const getParentDisplayName = (field, value, level) => {
                if (level === 0) {
                    // For first level, find in original dropDownItems
                    const parentOption = field.dropDownId.dropDownItems.find(item => item.value === value);
                    return parentOption?.key || value;
                } else {
                    // For deeper levels, we need to find it in the children structure
                    const baseFieldName = field.name.split('_child_')[0];
                    let currentOptions = field.dropDownId.dropDownItems;

                    // Traverse to the right level
                    for (let i = 0; i < level; i++) {
                        const levelFieldName = i === 0 ? baseFieldName : `${baseFieldName}_child_${i - 1}`;
                        const levelValue = i === 0 ?
                            fieldValues[baseFieldName] :
                            nestedDropdownValues[`${baseFieldName}_child_${i - 1}`];

                        const levelOption = currentOptions.find(item => item.value === levelValue);

                        if (!levelOption?.children) {
                            return value; // Fallback to the raw value
                        }

                        currentOptions = levelOption.children;
                    }

                    const parentOption = currentOptions.find(item => item.value === value);
                    return parentOption?.key || value;
                }
            };

            const parentDisplayName = getParentDisplayName(currentField, currentParentValue, currentLevel);

            const childField = {
                ...currentField,
                name: childFieldName,
                label: `${currentField.label} - ${parentDisplayName}`,
                dropDownId: {
                    dropDownItems: childOptions,
                    _id: `${currentField.dropDownId._id}_child_${currentLevel}`,
                    category: 'CRM_DROPDOWN',
                    name: `${currentField.dropDownId.name}_child_${currentLevel}`,
                    companyId: currentField.dropDownId.companyId
                },
                _id: `${currentField._id}_child_${currentLevel}`,
                required: childOptions.some(opt => opt.required) && childValue !== '',
                // Mark this as a nested field so we can handle it differently
                isNestedDropdown: true,
                nestedValue: childValue
            };

            const containers = [];

            // Create current level container with special handling for nested dropdowns
            const currentFieldElement = getNestedFieldElementContainer(childField, islastTwo);
            if (currentFieldElement) {
                containers.push(currentFieldElement);
            }

            // Recursively create deeper level containers if current level has a value
            if (childValue) {
                // Use the original field (currentField) to maintain access to the complete dropdown structure
                // but pass the child value for the next level
                const deeperContainers = buildContainers(currentField, childValue, currentLevel + 1);
                containers.push(...deeperContainers);
            }

            return containers;
        };

        return buildContainers(field, parentValue, level);
    }, [nestedDropdownValues, fieldValues, getChildDropdownOptions, getChildFieldName, t, getNestedFieldElementContainer]);

    // Function to create cascading dropdown containers for filtering mode
    const createCascadingFilterContainers = useCallback((field, islastTwo = false) => {
        if (!isFilteringMode || !field.dropDownId?.dropDownItems?.some(item => item.children && item.children.length > 0)) {
            return [];
        }

        const containers = [];
        const baseFieldName = field.name;

        // Get all selected parent values (array in filtering mode)
        const parentValues = fieldValues[baseFieldName] || [];

        if (!Array.isArray(parentValues) || parentValues.length === 0) {
            return [];
        }

        // Filtering-specific function to get child options at a specific level
        const getFilterChildDropdownOptions = (parentField, parentValue, level = 0) => {
            if (!parentField?.dropDownId?.dropDownItems || !parentValue) {
                return [];
            }

            // For level 0, search in the original dropDownItems
            if (level === 0) {
                const parentOption = parentField.dropDownId.dropDownItems.find(item => item.value === parentValue);

                if (!parentOption?.children) {
                    return [];
                }

                const transformedChildren = parentOption.children.map(child => ({
                    key: child.key,
                    value: child.value,
                    children: child.children || []
                }));

                return transformedChildren;
            } else {
                // For level 1+, find the parent option that contains this value
                // The parentValue here is actually a level 1+ value, and we want its children
                const baseFieldName = parentField.name.split('_child_')[0];

                // Find this value in the dropdown structure
                const findValueInStructure = (items, targetValue, currentLevel = 0) => {
                    for (const item of items) {
                        // Check if this is the target value at any level
                        if (item.value === targetValue) {
                            return item.children || [];
                        }

                        // Recursively search in children
                        if (item.children && item.children.length > 0) {
                            const result = findValueInStructure(item.children, targetValue, currentLevel + 1);
                            if (result.length > 0) {
                                return result;
                            }
                        }
                    }
                    return [];
                };

                const children = findValueInStructure(parentField.dropDownId.dropDownItems, parentValue);

                // Transform the children
                const transformedChildren = children.map(child => ({
                    key: child.key,
                    value: child.value,
                    children: child.children || []
                }));

                return transformedChildren;
            }
        };

        // Function to get all unique child options from selected parents at specific level
        const getAllChildOptionsFromParents = (parentValueArray, level = 0) => {
            const allChildOptions = new Map(); // Use Map to avoid duplicates

            parentValueArray.forEach(parentValue => {
                const childOptions = getFilterChildDropdownOptions(field, parentValue, level);
                childOptions.forEach(option => {
                    allChildOptions.set(option.value, option);
                });
            });

            const result = Array.from(allChildOptions.values());
            return result;
        };

        // Function to get options at a level based ONLY on actual selections at previous level
        const getOptionsBasedOnSelections = (targetLevel) => {
            if (targetLevel === 1) {
                // Level 1: Get children of selected parents (level 0)
                const result = getAllChildOptionsFromParents(parentValues, 0);
                return result;
            } else {
                // Level 2+: ONLY show options if previous level has actual selections
                const prevLevelFieldName = `${baseFieldName}_child_${targetLevel - 2}`;
                const prevLevelSelections = fieldValues[prevLevelFieldName] || [];

                if (prevLevelSelections.length > 0) {
                    // Use actual selections from previous level
                    const result = getAllChildOptionsFromParents(prevLevelSelections, targetLevel - 1);
                    return result;
                } else {
                    // No selections at previous level = no dropdown should be shown
                    return [];
                }
            }
        };

        // Function to build all possible cascading levels iteratively
        const buildAllCascadingLevels = () => {
            let currentLevel = 0;
            const maxLevels = 10; // Prevent infinite loops

            while (currentLevel < maxLevels) {
                // Get child options based ONLY on actual selections at previous level
                const childOptions = getOptionsBasedOnSelections(currentLevel + 1);

                if (childOptions.length === 0) {
                    break;
                }

                // Create the child field name
                const childFieldName = `${baseFieldName}_child_${currentLevel}`;

                // Get current child level name
                const getChildLevelName = () => {
                    // In filtering mode, use simple level numbering
                    if (isFilteringMode) {
                        return `${t('Level')} ${currentLevel + 2}`;
                    }

                    // In regular mode, try to find custom names
                    let searchValues;
                    if (currentLevel === 0) {
                        searchValues = parentValues;
                    } else {
                        const prevChildFieldName = `${baseFieldName}_child_${currentLevel - 1}`;
                        searchValues = fieldValues[prevChildFieldName] || [];
                        // If no selections, use parent values as fallback
                        if (searchValues.length === 0) {
                            searchValues = parentValues;
                        }
                    }

                    // Try to find custom name from any source value
                    for (const parentValue of searchValues) {
                        let currentOptions = field.dropDownId.dropDownItems;

                        // Navigate to the right level to find custom name
                        for (let i = 0; i <= currentLevel; i++) {
                            let valueToFind;
                            if (i === 0) {
                                valueToFind = parentValue;
                            } else {
                                const levelFieldName = `${baseFieldName}_child_${i - 1}`;
                                const levelValues = fieldValues[levelFieldName] || [];
                                if (levelValues.length > 0) {
                                    valueToFind = levelValues[0]; // Use first value for navigation
                                } else {
                                    // No value selected, can't navigate further for custom name
                                    break;
                                }
                            }

                            const option = currentOptions?.find(item => item.value === valueToFind);
                            if (option?.childLevelName) {
                                return option.childLevelName;
                            }
                            if (option?.children) {
                                currentOptions = option.children;
                            } else {
                                break;
                            }
                        }
                    }
                    return `${t('Child Level')} ${currentLevel + 1}`;
                };

                const childLevelName = getChildLevelName();

                // Create the nested dropdown field object
                const nestedField = {
                    _id: `${field._id}_child_${currentLevel}`,
                    name: childFieldName,
                    label: childLevelName,
                    type: 'select',
                    dropDownId: {
                        dropDownItems: childOptions
                    },
                    isNestedDropdown: true,
                    nestedLevel: currentLevel + 1,
                    parentFieldId: field._id,
                    isEditable: true, // Always editable in filtering mode
                    isEditableField: true // Always editable in filtering mode
                };

                // Get the field element container for this nested field
                const nestedFieldElement = getNestedFieldElementContainer(nestedField, islastTwo);

                if (nestedFieldElement) {
                    containers.push(nestedFieldElement);
                } else {
                    break;
                }

                // Move to next level
                currentLevel++;
            }
        };

        // Build all cascading levels
        buildAllCascadingLevels();

        return containers;
    }, [isFilteringMode, fieldValues, getChildDropdownOptions, getNestedFieldElementContainer, t]);

    let sectionContainerArr = []
    if (moduleSections) {
        sectionContainerArr = moduleSections.map(section => {
            const fieldContainerArr = []
            if (section.fields) {
                for (let i = 0; i < section.fields.length; i++) {
                    const field = section.fields[i]
                    const islastTwo = (section.fields.length - (i)) <= 2

                    if (i < section.fields.length - 1) {//Not the last one
                        // Check if this field will have nested containers
                        let nestedContainers = [];
                        if (field.type === 'select' && fieldValues[field.name]) {
                            if (isFilteringMode) {
                                // In filtering mode, use the cascading filter containers which handle multiple parents
                                nestedContainers = createCascadingFilterContainers(field, islastTwo);
                            } else {
                                // Handle both consolidated and simple values for regular mode
                                let parentValue = fieldValues[field.name];
                                if (typeof parentValue === 'object' && parentValue.parent) {
                                    parentValue = parentValue.parent;
                                }

                                nestedContainers = createNestedDropdownContainers(field, parentValue, 0, islastTwo);
                            }
                        }

                        // Create field element with nested containers attached (not as separate items)
                        const insertFieldElement = getFieldElementContainer(field, islastTwo)
                        if (insertFieldElement) {
                            if (nestedContainers.length > 0) {
                                // Combine parent field and nested containers in a single wrapper
                                const fieldWithNested = (
                                    <div className={styles['field-with-nested-wrapper']} key={`field-with-nested-${field._id}`}>
                                        {insertFieldElement}
                                        <div className={styles['nested-dropdown-container']} key={`nested-${field._id}`}>
                                            {nestedContainers}
                                        </div>
                                    </div>
                                );
                                fieldContainerArr.push(fieldWithNested);
                            } else {
                                fieldContainerArr.push(insertFieldElement);
                            }
                        }

                        if (field.order + 1 < section.fields[i + 1].order) {
                            const toAddElementsCount = section.fields[i + 1].order - field.order - 1
                            for (let j = 0; j < toAddElementsCount; j++) {
                                const insertFieldElement = getFieldElementContainer({ type: 'placeholder' }, islastTwo)
                                insertFieldElement && fieldContainerArr.push(insertFieldElement)
                            }
                        }
                    }
                    else {//last one
                        // Check if this last field will have nested containers
                        let nestedContainers = [];
                        if (field.type === 'select' && fieldValues[field.name]) {
                            if (isFilteringMode) {
                                // In filtering mode, use the cascading filter containers which handle multiple parents
                                nestedContainers = createCascadingFilterContainers(field, islastTwo);
                            } else {
                                // Handle both consolidated and simple values for regular mode
                                let parentValue = fieldValues[field.name];
                                if (typeof parentValue === 'object' && parentValue.parent) {
                                    parentValue = parentValue.parent;
                                }

                                nestedContainers = createNestedDropdownContainers(field, parentValue, 0, islastTwo);
                            }
                        }

                        // Create field element with nested containers attached (not as separate items)
                        const insertFieldElement = getFieldElementContainer(field, islastTwo)
                        if (insertFieldElement) {
                            if (nestedContainers.length > 0) {
                                // Combine parent field and nested containers in a single wrapper
                                const fieldWithNested = (
                                    <div className={styles['field-with-nested-wrapper']} key={`field-with-nested-last-${field._id}`}>
                                        {insertFieldElement}
                                        <div className={styles['nested-dropdown-container']} key={`nested-last-${field._id}`}>
                                            {nestedContainers}
                                        </div>
                                    </div>
                                );
                                fieldContainerArr.push(fieldWithNested);
                            } else {
                                fieldContainerArr.push(insertFieldElement);
                            }
                        }
                    }
                }
            }
            return (
                <section className={`${styles['single-record-body-section']}`}>
                    <h2 className={`${styles['section-title']}`}>{section.label}</h2>
                    <div className={`${styles['section-fields-container']}`}>
                        {fieldContainerArr}
                    </div>
                </section>
            )
        })
    }

    return (
        <main className={`${styles['single-record-body-container']}`}>
            {sectionContainerArr}
            {
                openSearchRecordModal?.isOpen &&
                <SubModal
                    modalTitle={t('Search in module X', { module: openSearchRecordModal?.moduleObj?.label })}
                    onHide={searchRecordModalToggel}
                    landscapeMode={true}
                >
                    <ModuleRecordRelation
                        onCancelClicked={searchRecordModalToggel}
                        mode={'link'}
                        moduleObj={openSearchRecordModal?.moduleObj}
                        relatedToRecordId={openSearchRecordModal?.relatedToRecordId}
                        onReloadGrid={onReload}
                        onLinkClicked={onLinkClickedHandler}
                        onUnLinkClicked={onUnLinkClickedHandler}
                        suppressOpenNewRecord={!(openSearchRecordModal?.relatedToRecordId && openSearchRecordModal?.moduleObj && relatedModuleObj) || false}
                        relatedModuleObj={relatedModuleObj}
                        onSelectConv={onSelectConv}
                        OnAddToDialListClicked={OnAddToDialListClicked}
                    />
                </SubModal>
            }
            {showFileManagerState?.isOpen && // TODO:
                <FileManager
                    onHide={() => setShowFileManager((prevState) => !prevState)}//
                    mediaTokenData={loggedUser?.mediaTokenData}
                    permissionType={loggedUser?.permissionType}
                    settings={settings}
                    onAttachFilesClicked={onAttachFileClickedHandler}
                    onAttachFilesWithoutGalleryClicked={onAttachFileClickedHandler}
                // fileTypesLimit={sendMediaSupportedTypes['whatsapp']}
                // fileCategoryLimit={fileCategoryLimitState}
                />
            }
        </main>
    )

}

export default ModuleSingleRecordSections